import { BookingWithDetail, EventSessionWithDetail, EventWithDetail } from "@garther/interfaces";
import { Button } from "@garther/ui/components";
import { cn, useI18n } from "@garther/ui/libs";
import { Calendar, Plus } from "lucide-react";
import { useState } from "react";

import { SessionFilter, useEventSessionsQuery } from "@/features/event/hooks/use-events-query";

import { CreateSessionForm } from "./create-session-form";
import { EventSessionCard } from "./event-session-card";
import { SessionAttendeeSheet } from "./session-attendee-sheet";

interface EventSessionsProps {
  event: EventWithDetail;
  bookings: BookingWithDetail[];
}

export function EventSessions({ event, bookings }: EventSessionsProps) {
  const { t } = useI18n();
  const [isCreateFormOpen, setIsCreateFormOpen] = useState(false);
  const [duplicateFrom, setDuplicateFrom] = useState<EventSessionWithDetail | null>(null);
  const [sessionForAttendees, setSessionForAttendees] = useState<EventSessionWithDetail | null>(null);
  const [filter, setFilter] = useState<SessionFilter>("upcoming");

  const { data: sessions = [] } = useEventSessionsQuery(event.id, filter);

  return (
    <>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-responsive-xl font-light text-text-primary uppercase font-literata mb-1">
              {t("eventSessions.title")}
            </p>
            <p className="text-responsive-base font-normal text-text-secondary">
              {t("eventSessions.subtitle")}
            </p>
          </div>
          <Button variant="outline" onClick={() => setIsCreateFormOpen(true)} className="">
            <Plus className="h-4 w-4 mr-2" />
            {t("eventSessions.createSession")}
          </Button>
        </div>

        {/* {event.sessions.length === 0 ? ( */}
        {/*   <div className="flex flex-col items-center justify-center py-16 px-4"> */}
        {/*     <div className="max-w-md text-center space-y-6"> */}
        {/*       <div className="flex justify-center"> */}
        {/*         <div className="relative"> */}
        {/*           <div className="absolute inset-0 bg-primary/10 rounded-full blur-2xl" /> */}
        {/*           <div className="relative bg-primary/5 p-6 rounded-full"> */}
        {/*             <Calendar className="w-14 h-14 text-primary" strokeWidth={1.5} /> */}
        {/*           </div> */}
        {/*         </div> */}
        {/*       </div> */}
        {/*       <div className="space-y-2"> */}
        {/*         <h3 className="text-responsive-2xl font-medium text-text-primary"> */}
        {/*           {t("eventSessions.empty.title")} */}
        {/*         </h3> */}
        {/*         <p className="text-responsive-md text-text-secondary"> */}
        {/*           {t("eventSessions.empty.description")} */}
        {/*         </p> */}
        {/*       </div> */}
        {/*       <Button */}
        {/*         variant="default" */}
        {/*         onClick={() => setIsCreateFormOpen(true)} */}
        {/*         className="mt-4 font-normal text-responsive-md" */}
        {/*       > */}
        {/*         <Plus className="w-4 h-4 mr-2" /> */}
        {/*         {t("eventSessions.empty.createFirst")} */}
        {/*       </Button> */}
        {/*     </div> */}
        {/*   </div> */}
        {/* ) : ( */}
        <div className="space-y-4">
          {/* Filter tabs */}
          <div className="flex gap-1 p-1 bg-background-highlight rounded-lg w-fit">
            {(["upcoming", "previous", "all"] as SessionFilter[]).map((f) => (
              <button
                key={f}
                onClick={() => setFilter(f)}
                className={cn(
                  "px-3 py-1.5 text-responsive-sm rounded-md transition-colors",
                  filter === f
                    ? "bg-background text-text-primary shadow-sm font-medium"
                    : "text-text-secondary hover:text-text-primary"
                )}
              >
                {t(`eventSessions.filter.${f}`)}
              </button>
            ))}
          </div>

          {sessions.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
              <Calendar className="w-10 h-10 text-text-secondary mb-3" strokeWidth={1.5} />
              <p className="text-responsive-md text-text-secondary">
                {filter === "upcoming"
                  ? t("eventSessions.empty.noUpcoming")
                  : t("eventSessions.empty.noPrevious")}
              </p>
            </div>
          ) : (
            sessions.map((session: EventSessionWithDetail) => (
              <EventSessionCard
                key={session.id}
                session={session}
                onDuplicate={() => {
                  setDuplicateFrom(session);
                  setIsCreateFormOpen(true);
                }}
                onViewAttendees={() => setSessionForAttendees(session)}
              />
            ))
          )}
        </div>
        {/* )} */}
      </div>

      <CreateSessionForm
        event={event}
        initialData={duplicateFrom}
        isOpen={isCreateFormOpen}
        onClose={() => setIsCreateFormOpen(false)}
      />

      <SessionAttendeeSheet
        session={sessionForAttendees}
        bookings={bookings}
        onClose={() => setSessionForAttendees(null)}
      />
    </>
  );
}
